export default "__VITE_ASSET__DFe8jZfk__"